<template>
  <Modal
      v-model="reportModal"
      :title="$t('label.analysis.exportReport.title')"
      width="80vw"
      :styles="{top:'65px'}"
      :mask="false" @on-ok="submit">
    <div slot="close" style="color:rgba(0,0,0,.45);">
      <!--      <Icon v-if="isFullscreen" type="ios-contract" size="25" @click.stop="isFullscreen = !isFullscreen"/>-->
      <!--      <Icon v-else type="ios-expand" size="25" @click.stop="isFullscreen = !isFullscreen"/>-->
      <Icon type="md-close" size="25"/>
    </div>
    <el-row>
      <el-col :span="6">
        <el-tree
            ref="tree"
            :data="treeData"
            show-checkbox
            node-key="id"
            style="color: #000000"
            :default-expanded-keys="defaultExpandedKeys"
            @check-change="checkChange"
            :props="defaultProps">
        </el-tree>
      </el-col>
      <el-col :span="18">
        <div style="height: 60vh;overflow:auto;">
          <div v-show="isCheck(1)">
            <h1>{{ $t('label.analysis.exportReport.summary') }}</h1>
            <p v-for="s in summary">{{s}}</p>
          </div>

          <div v-show="isCheck(2) || isCheck(21) || isCheck(22) || isCheck(23) || isCheck(24)">
            <h1>{{ $t('tabs.analysis.countryComparison') }}</h1>
            <div class="analysis-echart-div" v-show="isCheck(21)" id="project_count_country_contrast"></div>
            <Table border :columns="columns1" v-show="isCheck(21)"
                   :data="projectTableData1"
                   style="margin-top: 10px;">
            </Table>
            <div class="analysis-echart-div" v-show="isCheck(22)" id="project_count_country_trend"></div>
            <Table border :columns="projectColumns2" v-show="isCheck(22)"
                   :data="projectTableData2"
                   style="margin-top: 10px;">
            </Table>
            <div class="analysis-echart-div" v-show="isCheck(23)" id="project_amount_country_contrast"></div>
            <Table border :columns="columns3" v-show="isCheck(23)"
                   :data="projectTableData3"
                   style="margin-top: 10px;">
            </Table>
            <div class="analysis-echart-div" v-show="isCheck(24)" id="project_amount_country_trend"></div>
            <Table border :columns="projectColumns4" v-show="isCheck(24)"
                   :data="projectTableData4"
                   style="margin-top: 10px;">
            </Table>
          </div>
          <div v-show="isCheck(3) || isCheck(31) || isCheck(32) || isCheck(33) || isCheck(34)">
            <h1>{{ $t('tabs.analysis.industryComparison') }}</h1>
            <div class="analysis-echart-div" v-show="isCheck(31)" id="project_count_industry_contrast"></div>
            <Table border :columns="columns1" v-show="isCheck(31)"
                   :data="industryTableData1"
                   style="margin-top: 10px;">
            </Table>
            <div class="analysis-echart-div" v-show="isCheck(32)" id="project_count_industry_trend"></div>
            <Table border :columns="industryColumns2" v-show="isCheck(32)"
                   :data="industryTableData2"
                   style="margin-top: 10px;">
            </Table>
            <div class="analysis-echart-div" v-show="isCheck(33)" id="project_amount_industry_contrast"></div>
            <Table border :columns="columns3" v-show="isCheck(33)"
                   :data="industryTableData3"
                   style="margin-top: 10px;">
            </Table>
            <div class="analysis-echart-div" v-show="isCheck(34)" id="project_amount_industry_trend"></div>
            <Table border :columns="industryColumns4" v-show="isCheck(34)"
                   :data="industryTableData4"
                   style="margin-top: 10px;">
            </Table>
          </div>
          <div v-show="isCheck(4) || isCheck(41) || isCheck(42) || isCheck(43) || isCheck(44)">
            <h1>{{ $t('tabs.analysis.networkVolume') }}</h1>
            <div class="analysis-echart-div" v-show="isCheck(41)" id="network_trend"></div>
            <Table border :columns="columns5" v-show="isCheck(41)"
                   :data="networkTableData1"
                   style="margin-top: 10px;">
            </Table>
            <div class="analysis-echart-div" v-show="isCheck(42)" id="network_from_trend"></div>
            <Table border :columns="networkColumns2" v-show="isCheck(42)"
                   :data="networkTableData2"
                   style="margin-top: 10px;">
            </Table>
            <div class="analysis-echart-div" v-show="isCheck(43)" id="network_from_distribution"></div>
            <Table border :columns="columns8" v-show="isCheck(43)"
                   :data="networkTableData3"
                   style="margin-top: 10px;">
            </Table>
            <div class="analysis-echart-div" v-show="isCheck(44)" id="network_from_contrast"></div>
            <Table border :columns="columns9" v-show="isCheck(44)"
                   :data="networkTableData4"
                   style="margin-top: 10px;">
            </Table>
          </div>
          <div v-show="isCheck(5) || isCheck(51) || isCheck(52) || isCheck(53) || isCheck(54) || isCheck(55) || isCheck(56)">
            <h1>{{ $t('tabs.analysis.positiveAndNegativeSidesOfInformation') }}</h1>
            <div class="analysis-echart-div" v-show="isCheck(51)" id="information_contrast"></div>
            <Table border :columns="columns10" v-show="isCheck(51)"
                   :data="informationTableData1"
                   style="margin-top: 10px;">
            </Table>
            <div class="analysis-echart-div" v-show="isCheck(52)" id="information_percent"></div>
            <Table border :columns="columns11" v-show="isCheck(52)"
                   :data="informationTableData2"
                   style="margin-top: 10px;">
            </Table>
            <div class="analysis-echart-div" v-show="isCheck(53)" id="information_positive_trend"></div>
            <Table border :columns="columns12" v-show="isCheck(53)"
                   :data="informationTableData3"
                   style="margin-top: 10px;">
            </Table>
            <div class="analysis-echart-div" v-show="isCheck(54)" id="information_positive_distribution"></div>
            <Table border :columns="columns13" v-show="isCheck(54)"
                   :data="informationTableData4"
                   style="margin-top: 10px;">
            </Table>
            <div class="analysis-echart-div" v-show="isCheck(55)" id="information_trend"></div>
            <Table border :columns="columns14" v-show="isCheck(55)"
                   :data="informationTableData5"
                   style="margin-top: 10px;">
            </Table>
            <div class="analysis-echart-div" v-show="isCheck(56)" id="information_distribution"></div>
            <Table border :columns="columns15" v-show="isCheck(56)"
                   :data="informationTableData6"
                   style="margin-top: 10px;">
            </Table>
          </div>
          <div v-show="isCheck(6) || isCheck(61) || isCheck(62) || isCheck(63) || isCheck(64)">
            <h1>{{ $t('tabs.analysis.opportunityAnalysis') }}</h1>
            <div class="analysis-echart-div" v-show="isCheck(61)" id="business_country_trend"></div>
            <Table border :columns="businessColumns1" v-show="isCheck(61)"
                   :data="businessTableData1"
                   style="margin-top: 10px;">
            </Table>
            <div class="analysis-echart-div" v-show="isCheck(62)" id="business_industry_trend"></div>
            <Table border :columns="businessColumns2" v-show="isCheck(62)"
                   :data="businessTableData2"
                   style="margin-top: 10px;">
            </Table>
            <div class="analysis-echart-div" v-show="isCheck(63)" id="business_country_distribution"></div>
            <Table border :columns="columns8" v-show="isCheck(63)"
                   :data="businessTableData3"
                   style="margin-top: 10px;">
            </Table>
            <div class="analysis-echart-div" v-show="isCheck(64)" id="business_industry_distribution"></div>
            <Table border :columns="columns16" v-show="isCheck(64)"
                   :data="businessTableData4"
                   style="margin-top: 10px;">
            </Table>
          </div>
          <div v-show="isCheck(7) || isCheck(71) || isCheck(72) || isCheck(73) || isCheck(74)">
            <h1>{{ $t('tabs.analysis.riskAnalysis') }}</h1>
            <div class="analysis-echart-div" v-show="isCheck(71)" id="risk_category_trend"></div>
            <Table border :columns="riskColumns1" v-show="isCheck(71)"
                   :data="riskTableData1"
                   style="margin-top: 10px;">
            </Table>
            <div class="analysis-echart-div" v-show="isCheck(72)" id="risk_country_trend"></div>
            <Table border :columns="riskColumns2" v-show="isCheck(72)"
                   :data="riskTableData2"
                   style="margin-top: 10px;">
            </Table>
            <div class="analysis-echart-div" v-show="isCheck(73)" id="risk_category_distribution"></div>
            <Table border :columns="columns16" v-show="isCheck(73)"
                   :data="riskTableData3"
                   style="margin-top: 10px;">
            </Table>
            <div class="analysis-echart-div" v-show="isCheck(74)" id="risk_country_distribution"></div>
            <Table border :columns="columns8" v-show="isCheck(74)"
                   :data="riskTableData4"
                   style="margin-top: 10px;">
            </Table>
          </div>
          <div v-show="isCheck(8)">
            <h1>{{ $t('label.analysis.exportReport.projectInformation') }}</h1>

            <Table border :columns="columns"
                   :data="tableData"
                   style="margin-top: 10px;">
              <template slot-scope="{row, column, index}" slot="sort">
                <span>{{index+1}}</span>
              </template>
               <template slot="enterprises" slot-scope="{ row }">
          <span v-if="Array.isArray(row.enterprises) && row.enterprises.length > 0">{{row.enterprises.join(',')}}</span>
        <span v-else>-</span>
        </template>
              <template slot-scope="{ row }" slot="title">
                <span v-html="row.title"></span>
              </template>
            </Table>
          </div>
        </div>
      </el-col>
    </el-row>
     <div slot="footer" class="dialog-footer" style="display: flex; align-items: center;">
      <span style="flex: 1;"></span>
      <el-radio-group v-model="watermark" style="margin-right: 20px;">
        <el-radio :label="0">{{ $t('label.analysis.exportReport.watermarkNo') }}</el-radio>
        <el-radio :label="1">{{ $t('label.analysis.exportReport.watermark') }}</el-radio>
      </el-radio-group>
      <el-button @click="reportModal = false">{{ $t('label.analysis.exportReport.cancel') }}</el-button>
      <el-button type="primary" @click="submit">{{ $t('label.analysis.exportReport.confirm') }}</el-button>
    </div>
    <Spin v-if="spinShow" class="pbrSpin" fix size="large" />
  </Modal>

</template>

<script>
import * as echarts from 'echarts';
import {chartColors, numberConversion, xLabelColor} from './constant'
import {contentType, exportFilePost, exportFile} from '../apis/common'
import {baseUrl} from '../common/js/pbrAxios'

const chartBarOption = {
  backgroundColor: '#ffffff',
  color: chartColors,
  title: {
    textStyle: {
      fontSize: 14
    },
  },
  tooltip: {trigger: 'item',confine: true},
  legend: {
    show:false,
    top:50,
    itemWidth: 16,
    itemHeight: 10,
    padding: [0, 10],
    textStyle: {
      color: '#333333',
      lineHeight: 1,
    }
  },
  xAxis: {
    type: 'category',
    axisLine: {
      show: false
    },
    axisLabel: {
      fontSize: 12,
      color: '#333333',
      interval:0,
      rotate:40
    },
    axisTick: {
      show: false,
    },
  },
  grid: {
    bottom: 0,
    left: 0,
    right: 0,
    top:60,
    containLabel: true
  },
  yAxis: {
    type: 'value',
    axisTick: {
      show: false,
    },
    axisLabel: {
      fontSize: 12,
      color: '#333333',
      formatter: function(value) {
        return numberConversion(value);
      },
    },
    splitLine: {
      lineStyle: {
        color: '#aaaaaa',
        type: 'dashed',
      }
    }
  },
  series: []
};

const chartLineOption = {
  backgroundColor: '#ffffff',
  color: chartColors,
  title: {
    textStyle: {
      fontSize: 14
    },
  },
  tooltip: {
    trigger: 'axis'
  },
  legend: {
    show:false,
    top: 50,
    itemWidth: 16,
    padding: [0, 10],
    itemHeight: 10,
    height: 'auto',
    textStyle: {
      color: '#333333',
      lineHeight: 1,
    }
  },
  grid: {
    bottom: 0,
    top:60,
    left: 0,
    right: 0,
    containLabel: true
  },
  xAxis: {
    type: 'category',
    boundaryGap: true,
    axisLine: {
      show: false
    },
    axisLabel: {
      fontSize: 12,
      color: '#333333',
      interval:0,
      rotate:40
    },
    axisTick: {
      show: false,
    },
  },
  yAxis: {
    type: 'value',
    axisTick: {
      show: false,
    },
    axisLabel: {
      fontSize: 12,
      color: '#333333',
      formatter: function(value) {
        return numberConversion(value);
      },
    },
    splitLine: {
      lineStyle: {
        color: '#aaaaaa',
        type: 'dashed',
      }
    }
  },
  series: []
};

const pieChartOption = {
  backgroundColor: '#ffffff',
  color: chartColors,
  title: {
    textStyle: {
      fontSize: 14
    },
  },
  tooltip: {
    trigger: 'item',
    confine: true
  },
  legend: {
    show:false,
    orient: 'horizontal',
    top: 30,
    itemWidth: 10,
    itemHeight: 10,
    padding: [0, 10],
    textStyle: {
      color: '#333333',
      lineHeight: 1,
    }
  },
  series: [
    {
      type: 'pie',
      radius: '50%',
      label: {
        color: '#333333',
      },
      emphasis: {
        itemStyle: {
          shadowBlur: 10,
          shadowOffsetX: 0,
          shadowColor: 'rgba(0, 0, 0, 0.5)'
        }
      }
    }
  ]
};
export default {
  name: 'GenerateReport',
  props: {

  },
  data () {
    return {
      reportModal: false,
      checked: false,
      formItem: {
        summary: []
      },
      isFullscreen: true,
      count: 10,
      spinShow: false,
      watermark: 1,

      defaultProps: {
        id: 'id',
        children: 'children',
        label: 'label'
      },
      selected: [],
      treeData: [
        {
          id: 1,
          label: `1、${this.$t('label.analysis.exportReport.summary')}`
        }, {
          id: 2,
          label: `2、${this.$t('tabs.analysis.countryComparison')}`,
          children: [{
            pid: 2,
            id: 21,
            label: `${this.$t('charts.analysis.countryComparison.countryComparisonOfProjectQuantity')}`
          }, {
            id: 22,
            pid: 2,
            label: `${this.$t('charts.analysis.countryComparison.nationalTrendChartOfProjectQuantity')}`
          }, {
            id: 23,
            pid: 2,
            label: `${this.$t('charts.analysis.countryComparison.countryComparisonChartOfProjectAmount')}`
          }, {
            id: 24,
            pid: 2,
            label: `${this.$t('charts.analysis.countryComparison.nationalTrendChartOfProjectAmount')}`
          }]
        }, {
          id: 3,
          label: `3、${this.$t('tabs.analysis.industryComparison')}`,
          children: [{
            id: 31,
            pid: 3,
            label: `${this.$t('charts.analysis.industryComparison.projectQuantityIndustryComparisonChart')}`
          }, {
            id: 32,
            pid: 3,
            label: `${this.$t('charts.analysis.industryComparison.projectQuantityIndustryTrendChart')}`
          }, {
            id: 33,
            pid: 3,
            label: `${this.$t('charts.analysis.industryComparison.industryComparisonChartOfProjectAmount')}`
          }, {
            id: 34,
            pid: 3,
            label: `${this.$t('charts.analysis.industryComparison.industryTrendChartOfProjectAmount')}`
          }]}, {
          id: 4,
          label: `4、${this.$t('tabs.analysis.networkVolume')}`,
          children: [{
            id: 41,
            pid: 4,
            label: `${this.$t('charts.analysis.networkVolume.volumeInformationTrendChart')}`
          }, {
            id: 42,
            pid: 4,
            label: `${this.$t('charts.analysis.networkVolume.informationSourceTrendChart')}`
          }, {
            id: 43,
            pid: 4,
            label: `${this.$t('charts.analysis.networkVolume.distributionMapOfInformationSources')}`
          }, {
            id: 44,
            pid: 4,
            label: `${this.$t('charts.analysis.networkVolume.comparisonOfInformationSources')}`
          }]
        }, {
          id: 5,
          label: `5、${this.$t('tabs.analysis.positiveAndNegativeSidesOfInformation')}`,
          children: [{
            pid: 5,
            id: 51,
            label: `${this.$t('charts.analysis.positiveAndNegativeSidesOfInformation.informationPositiveAndNegativeComparisonDiagram')}`
          }, {
            id: 52,
            pid: 5,
            label: `${this.$t('charts.analysis.positiveAndNegativeSidesOfInformation.proportionOfSensitiveInformation')}`
          }, {
            id: 53,
            pid: 5,
            label: `${this.$t('charts.analysis.positiveAndNegativeSidesOfInformation.positiveInformationTrendChart')}`
          }, {
            id: 54,
            pid: 5,
            label: `${this.$t('charts.analysis.positiveAndNegativeSidesOfInformation.distributionOfPositiveInformationSources')}`
          },{
            id: 55,
            pid: 5,
            label: `${this.$t('charts.analysis.positiveAndNegativeSidesOfInformation.sensitiveInformationTrendChart')}`
          }, {
            id: 56,
            pid: 5,
            label: `${this.$t('charts.analysis.positiveAndNegativeSidesOfInformation.distributionOfSensitiveInformationSources')}`
          }]
        }, {
          id: 6,
          label: `6、${this.$t('tabs.analysis.opportunityAnalysis')}`,
          children: [{
            pid: 6,
            id: 61,
            label: `${this.$t('charts.analysis.opportunityAnalysis.businessOpportunityCountryTrendChart')}`
          }, {
            id: 62,
            pid: 6,
            label: `${this.$t('charts.analysis.opportunityAnalysis.businessOpportunityTypeTrendChart')}`
          }, {
            id: 63,
            pid: 6,
            label: `${this.$t('charts.analysis.opportunityAnalysis.businessOpportunityCountryDistributionMap')}`
          }, {
            id: 64,
            pid: 6,
            label: `${this.$t('charts.analysis.opportunityAnalysis.businessOpportunityTypeDistributionMap')}`
          }]
        }, {
          id: 7,
          label: `7、${this.$t('tabs.analysis.riskAnalysis')}`,
          children: [{
            id: 71,
            pid: 7,
            label: `${this.$t('charts.analysis.riskAnalysis.riskEventCategoryTrendChart')}`
          }, {
            id: 72,
            pid: 7,
            label: `${this.$t('charts.analysis.riskAnalysis.nationalTrendChartOfRiskEvents')}`
          }, {
            id: 73,
            pid: 7,
            label: `${this.$t('charts.analysis.riskAnalysis.riskEventCategoryDistributionMap')}`
          }, {
            id: 74,
            pid: 7,
            label: `${this.$t('charts.analysis.riskAnalysis.countryDistributionMapOfRiskEvents')}`
          }]
        }, {
          id: 8,
          label: `8、${this.$t('label.analysis.exportReport.projectInformation')}`
        }
      ],
      defaultExpandedKeys: [],
      selectedTree: [],
      queryParams: {},
      summary: [],
      tableData: [],
      columns: [
        {
          title: this.$t('table.project.main.no'),
          width: 50,
          align: 'center',
          slot: 'sort'
        },
        {
          title: this.$t('table.project.main.title'),
          slot: 'title',
          minWidth: 300,
        },
        {
          title: this.$t('table.project.main.amount'),
          key: 'amount',
          align: 'center',
          width: 130,
        },
        {
          title: this.$t('table.project.main.industry'),
          key: 'industry',
          width: 100,
          align: 'center',
        },
        {
          title: this.$t('table.project.main.state'),
          key: 'status',
          width: 100,
          align: 'center',
        },
        {
          title: this.$t('table.project.main.country'),
          key: 'country',
          width: 100,
          align: 'center',
        },
        {
          title: this.$t('table.project.main.date'),
          key: 'signDate',
          width: 100,
          align: 'center',
        },
         {
          title: this.$t('table.project.main.enterprise'),
          key: 'enterprises',
          width: 100,
          align: 'center',
          slot: 'enterprises'
        }
      ],

      /*图表下表格*/
      commonColumns:[
        {
          type:'index',
          title: this.$t('table.project.main.no'),
          width: 50,
          align: 'center'
        },
        {
          title: this.$t('table.project.main.country'),
          key: 'name',
          width: 140,
          align: 'center',
        },
      ],
      columns1:[
        {
          type:'index',
          title: this.$t('table.project.main.no'),
          width: 50,
          align: 'center'
        },
        {
          title: this.$t('table.project.main.country'),
          key: 'name',
          align: 'center',
        },
        {
          title: this.$t('table.analysis.num'),
          key: 'num',
          align: 'center',
        },
      ],
      columns3:[
        {
          type:'index',
          title: this.$t('table.project.main.no'),
          width: 50,
          align: 'center'
        },
        {
          title: this.$t('table.project.main.country'),
          key: 'name',
          align: 'center',
        },
        {
          title: this.$t('table.analysis.amount'),
          key: 'amount',
          align: 'center',
        },
      ],
      columns5:[
        {
          type:'index',
          title: this.$t('table.project.main.no'),
          width: 50,
          align: 'center'
        },
        {
          title: this.$t('table.analysis.date'),
          key: 'time',
          align: 'center',
        },
        {
          title: this.$t('table.analysis.num'),
          key: 'num',
          align: 'center',
        },
      ],
      columns7:[
        {
          type:'index',
          title: this.$t('table.project.main.no'),
          width: 50,
          align: 'center'
        },
        {
          title: this.$t('table.analysis.source'),
          key: 'name',
          align: 'center',
        },
        {
          title: this.$t('table.analysis.num'),
          key: 'num',
          align: 'center',
        },
      ],
      columns8:[
        {
          type:'index',
          title: this.$t('table.project.main.no'),
          width: 50,
          align: 'center'
        },
        {
          title: this.$t('table.project.main.country'),
          key: 'name',
          align: 'center',
        },
        {
          title: this.$t('table.analysis.num'),
          key: 'num',
          align: 'center',
        },
        {
          title: this.$t('table.analysis.percentage'),
          key: 'percentage',
          align: 'center',
        },
      ],
      columns9:[
        {
          type:'index',
          title: this.$t('table.project.main.no'),
          width: 50,
          align: 'center'
        },
        {
          title: this.$t('table.analysis.source'),
          key: 'name',
          align: 'center',
        },
        {
          title: this.$t('table.analysis.num'),
          key: 'num',
          align: 'center',
        },
        {
          title: this.$t('table.analysis.percentage'),
          key: 'percentage',
          align: 'center',
        },
      ],
      columns10:[
        {
          type:'index',
          title: this.$t('table.project.main.no'),
          width: 50,
          align: 'center'
        },
        {
          title: this.$t('table.analysis.date'),
          key: 'time',
          align: 'center',
        },
        {
          title: this.$t('table.analysis.positive'),
          key: 'positive',
          align: 'center',
        },
        {
          title: this.$t('table.analysis.negative'),
          key: 'negative',
          align: 'center',
        },
      ],
      columns11:[
        {
          type:'index',
          title: this.$t('table.project.main.no'),
          width: 50,
          align: 'center'
        },
        {
          title: this.$t('table.project.main.country'),
          key: 'name',
          align: 'center',
        },
        {
          title: this.$t('table.analysis.positive'),
          key: 'positive',
          align: 'center',
        },
        {
          title: this.$t('table.analysis.negative'),
          key: 'negative',
          align: 'center',
        },
      ],
      columns12:[
        {
          type:'index',
          title: this.$t('table.project.main.no'),
          width: 50,
          align: 'center'
        },
        {
          title: this.$t('table.analysis.date'),
          key: 'time',
          align: 'center',
        },
        {
          title: this.$t('table.analysis.positive'),
          key: 'num',
          align: 'center',
        },
      ],
      columns13:[
        {
          type:'index',
          title: this.$t('table.project.main.no'),
          width: 50,
          align: 'center'
        },
        {
          title: this.$t('table.analysis.source'),
          key: 'name',
          align: 'center',
        },
        {
          title: this.$t('table.analysis.positive'),
          key: 'num',
          align: 'center',
        },
        {
          title: this.$t('table.analysis.percentage'),
          key: 'percentage',
          align: 'center',
        },
      ],
      columns14:[
        {
          type:'index',
          title: this.$t('table.project.main.no'),
          width: 50,
          align: 'center'
        },
        {
          title: this.$t('table.analysis.date'),
          key: 'time',
          align: 'center',
        },
        {
          title: this.$t('table.analysis.negative'),
          key: 'num',
          align: 'center',
        },
      ],
      columns15:[
        {
          type:'index',
          title: this.$t('table.project.main.no'),
          width: 50,
          align: 'center'
        },
        {
          title: this.$t('table.analysis.source'),
          key: 'name',
          align: 'center',
        },
        {
          title: this.$t('table.analysis.negative'),
          key: 'num',
          align: 'center',
        },
        {
          title: this.$t('table.analysis.percentage'),
          key: 'percentage',
          align: 'center',
        },
      ],
      columns16:[
        {
          type:'index',
          title: this.$t('table.project.main.no'),
          width: 50,
          align: 'center'
        },
        {
          title: this.$t('table.analysis.type'),
          key: 'name',
          align: 'center',
        },
        {
          title: this.$t('table.analysis.num'),
          key: 'num',
          align: 'center',
        },
        {
          title: this.$t('table.analysis.percentage'),
          key: 'percentage',
          align: 'center',
        },
      ],

      projectColumns2:[],
      projectColumns4:[],
      projectTableData1:[],
      projectTableData2:[],
      projectTableData3:[],
      projectTableData4:[],
      projectTableData2_original:[],
      projectTableData4_original:[],

      projectCountCountryContrastImg: '',
      projectCountCountryTrendImg: '',
      projectAmountCountryContrastImg: '',
      projectAmountCountryTrendImg: '',

      industryColumns2:[],
      industryColumns4:[],
      industryTableData1:[],
      industryTableData2:[],
      industryTableData3:[],
      industryTableData4:[],
      industryTableData2_original:[],
      industryTableData4_original:[],

      projectCountIndustryContrastImg: '',
      projectCountIndustryTrendImg: '',
      projectAmountIndustryContrastImg: '',
      projectAmountIndustryTrendImg: '',

      networkColumns2:[],
      networkTableData1:[],
      networkTableData2:[],
      networkTableData2_original:[],
      networkTableData3:[],
      networkTableData4:[],

      networkTrendImg: '',
      networkFromTrendImg: '',
      networkFromDistributionImg: '',
      networkFromContrastImg: '',

      informationTableData1:[],
      informationTableData2:[],
      informationTableData3:[],
      informationTableData4:[],
      informationTableData5:[],
      informationTableData6:[],

      informationContrastImg: '',
      informationPercentImg: '',
      positiveLineModelsImg: '',
      positiveSourceModelsImg: '',
      informationTrendImg: '',
      informationDistributionImg: '',

      businessColumns1:[],
      businessColumns2:[],
      businessTableData1_original:[],
      businessTableData2_original:[],
      businessTableData1:[],
      businessTableData2:[],
      businessTableData3:[],
      businessTableData4:[],

      businessCountryTrendImg: '',
      businessIndustryTrendImg: '',
      businessCountryDistributionImg: '',
      businessIndustryDistributionImg: '',

      riskColumns1:[],
      riskColumns2:[],
      riskTableData1_original:[],
      riskTableData2_original:[],
      riskTableData1:[],
      riskTableData2:[],
      riskTableData3:[],
      riskTableData4:[],
      riskCategoryTrendImg: '',
      riskCountryTrendImg: '',
      riskCountryDistributionImg: '',
      riskCategoryDistributionImg: '',
      imgOption:{},
      reportMessage:null,
    }
  },
  methods: {
    getTheme() {
      return this.$store.state.brpaModule.theme || 'white';
    },
    open (queryParams) {
      this.queryParams = queryParams
      this.reportModal = true
      this.loadData()
    },
    generateReport () {

    },
    checkChange (data, checked, indeterminate) {
      if (!this.reportModal){
        return
      }
      switch (data.id) {
        case 1:
          this.getModelChartsData();
          break;
        case 2:
          this.countryLoad();
          break;
        case 3:
          this.industryLoad();
          break;
        case 4:
          this.networkLoad();
          break;
        case 5:
          this.informationLoad();
          break;
        case 6:
          this.businessLoad();
          break;
        case 7:
          this.riskLoad();
          break;
        default: break;
      }
      this.selectedTree = []
      this.selectedTree = this.$refs.tree.getCheckedNodes()
    },
    isCheck (id) {
      for (let m = 0; m < this.selectedTree.length; m++) {
        if (id === this.selectedTree[m].id) {
          return true
        }
      }
      return false
    },
    changeColumn(d){
      let arr = []
      d[0].times.forEach(n => {
        let obj = {
            title: n,
            key: n,
            width: 140,
            align: 'center',
          }
        arr.push(obj)
      })
      return arr
    },
    changeTableData(d,key){
      d.forEach(m => {
        m.times.forEach((item,i) => {
          m[item] = m[key][i]
        })
      })
      return d
    },
    loadData () {
      this.getModelChartsData();
      this.countryLoad();
      this.industryLoad();
      this.networkLoad();
      this.informationLoad();
      this.businessLoad();
      this.riskLoad();
    },

    countryLoad() {
      let param = {
        from: 'cn',
        module: 'gj' , // 模块 gj/hy/wl/xx/sj/fx 分布式国家对比、行业对比、网络声量、信息正负面、商机分析、风险分析  默认为国家对比
      };
      param = Object.assign(param, this.queryParams);
      this.$pbrAxios.post('/front/analyses/search',param).then((data) => {
        let success = data.success;
        if (success){
          let nationModels = data.result.nationModels;
          let nationLineModels = data.result.nationLineModels;
          let amountModels = data.result.amountModels;
          let amountLineModels = data.result.amountLineModels;

          this.projectCountCountryContrast(nationModels);
          this.projectCountCountryTrend(nationLineModels);
          this.projectAmountCountryContrast(amountModels);
          this.projectAmountCountryTrend(amountLineModels);

          this.projectTableData1 = nationModels
          this.projectTableData3 = amountModels

          this.projectColumns2 = this.commonColumns.concat(this.changeColumn(nationLineModels))
          this.projectColumns4 = this.commonColumns.concat(this.changeColumn(amountLineModels))
          this.projectTableData2 = this.changeTableData(nationLineModels,'nums')
          this.projectTableData4 = this.changeTableData(amountLineModels,'amount')
          this.projectTableData2_original = nationLineModels
          this.projectTableData4_original = amountLineModels
        } else {

        }
      }).finally(() => {
      })
    },

    projectCountCountryContrast(obj) {
      let projectCountCountryContrast = echarts.init(document.getElementById("project_count_country_contrast"));
      if (obj.length<=0){
        projectCountCountryContrast.clear();
        obj.push({num:0, name:''})
      }
      let seriesData = [];
      for(let i=0;i<obj.length;i++) {
        let serData = {};
        serData['name'] = obj[i].name;
        serData['type'] = 'bar';
        serData['data'] = [obj[i].num];
        serData['id'] = obj[i].id;
        serData['barMaxWidth'] = 30
        serData['itemStyle'] = {color: chartColors[i]};
        seriesData[i] = serData;
      }
      const option = {
        title: {
          text: `${this.$t('charts.analysis.countryComparison.countryComparisonOfProjectQuantity')}`,
          subtext: `${this.$t('charts.analysis.unit')} : ${this.$t('charts.analysis.ge')} `,
        },
        legend: {
          data: obj.map(nation => nation.name),
        },
        xAxis: {
          show:false,
          data:[""],
          //data: obj.map(nation => nation.name),
          axisLabel: {
            interval: 0,
            rotate: 45,
            formatter: function(params) {
              let val = "";
              let show = localStorage.getItem('locale') === 'cn' ? 4 : 10;
              if (params.length > show) {
                val = params.substr(0, show) + '...';
                return val;
              } else {
                return params;
              }
            }
          }
        },
        yAxis: {
          type: 'value',
          axisLabel:{
            formatter: function(value) {
              return numberConversion(value);
            },
          }
        },
        series: seriesData

      };
      projectCountCountryContrast.clear();
      projectCountCountryContrast.setOption(chartBarOption);
      projectCountCountryContrast.setOption(option);

      setTimeout(() => {
        this.projectCountCountryContrastImg = projectCountCountryContrast.getDataURL(this.imgOption).substring(22);
      }, 1000)
    },
    projectCountCountryTrend(obj) {
      let projectCountCountryTrend = echarts.init(document.getElementById("project_count_country_trend"));
      if (obj.length<=0){
        projectCountCountryTrend.clear();
        obj.push({name:'',nums:[0]})
      }
      let series = [];
      for (let i = 0; i < obj.length; i++) {
        let ser = {};
        ser["name"] = obj[i].name;
        ser["data"] = obj[i].nums;
        ser["type"] = "line";
        series[i] = ser;
      }
      const option = {
        title: {
          text: `${this.$t('charts.analysis.countryComparison.nationalTrendChartOfProjectQuantity')}`,
          subtext: `${this.$t('charts.analysis.unit')} : ${this.$t('charts.analysis.ge')} `,
        },
        xAxis: {
          data: obj[0].times,
        },
        series: series,
      };
      projectCountCountryTrend.clear();
      projectCountCountryTrend.setOption(chartLineOption);
      projectCountCountryTrend.setOption(option);

      setTimeout(() => {
        this.projectCountCountryTrendImg = projectCountCountryTrend.getDataURL(this.imgOption).substring(22);
      }, 1000)
    },
    projectAmountCountryContrast(obj) {
      let projectAmountCountryContrast = echarts.init(document.getElementById("project_amount_country_contrast"));
      if (obj.length<=0){
        projectAmountCountryContrast.clear();
        // return ;
        obj.push({ name:'',amount:0})
      }
      let seriesData = [];
      for(let i=0;i<obj.length;i++) {
        let serData = {};
        serData['name'] = obj[i].name;
        serData['type'] = 'bar';
        serData['data'] = [obj[i].amount];
        serData['id'] = obj[i].id;
        serData['barMaxWidth'] = 30
        serData['itemStyle'] = {color: chartColors[i]};
        seriesData[i] = serData;
      }
      const option = {
        title: {
          text: `${this.$t('charts.analysis.countryComparison.countryComparisonChartOfProjectAmount')}`,
          subtext: `${this.$t('charts.analysis.unit')} : ${this.$t('charts.analysis.yuan')} `,
        },
        legend: {
          data: obj.map(nation => nation.name),
        },
        xAxis: {
          show:false,
          data:[""],
          //data: obj.map(amount => amount.name),
          axisLabel: {
            interval: 0,
            rotate: 45,
            formatter: function(params) {
              let val = "";
              let show = localStorage.getItem('locale') === 'cn' ? 4 : 10;
              if (params.length > show) {
                val = params.substr(0, show) + '...';
                return val;
              } else {
                return params;
              }
            }
          }
        },
        series: seriesData
      };
      projectAmountCountryContrast.clear();
      projectAmountCountryContrast.setOption(chartBarOption);
      projectAmountCountryContrast.setOption(option);

      setTimeout(() => {
        this.projectAmountCountryContrastImg = projectAmountCountryContrast.getDataURL(this.imgOption).substring(22);
      }, 1000)
    },
    projectAmountCountryTrend(obj) {
      let projectAmountCountryTrend = echarts.init(document.getElementById("project_amount_country_trend"));
      if (obj.length<=0){
        projectAmountCountryTrend.clear();
        // return ;
        obj.push({ name:'',amount:[0]})
      }
      let series = [];
      for (let i = 0; i < obj.length; i++) {
        let ser = {};
        ser["name"] = obj[i].name;
        ser["data"] = obj[i].amount;
        ser["type"] = "line";
        series[i] = ser;
      }
      const option = {
        title: {
          text: `${this.$t('charts.analysis.countryComparison.nationalTrendChartOfProjectAmount')}`,
          subtext: `${this.$t('charts.analysis.unit')} : ${this.$t('charts.analysis.yuan')} `,
        },
        xAxis: {
          data: obj[0].times,
        },
        series: series,
      };
      projectAmountCountryTrend.clear();
      projectAmountCountryTrend.setOption(chartLineOption);
      projectAmountCountryTrend.setOption(option);

      setTimeout(() => {
        this.projectAmountCountryTrendImg = projectAmountCountryTrend.getDataURL(this.imgOption).substring(22);
      }, 1000)
    },

    industryLoad() {
      let param = {
        from: 'cn',
        module: 'hy' , // 模块 gj/hy/wl/xx/sj/fx 分布式国家对比、行业对比、网络声量、信息正负面、商机分析、风险分析  默认为国家对比
      };
      param = Object.assign(param, this.queryParams);

      this.$pbrAxios.post('/front/analyses/search',param).then((data) => {
        let success = data.success;
        if (success){
          let models = data.result.models;
          let lineModels = data.result.lineModels;
          let amountModels = data.result.amountModels;
          let amountLineModels = data.result.amountLineModels;

          this.projectCountIndustryContrast(models);
          this.projectCountIndustryTrend(lineModels);
          this.projectAmountIndustryContrast(amountModels);
          this.projectAmountIndustryTrend(amountLineModels);

          this.industryTableData1 = models
          this.industryTableData3 = amountModels

          this.industryColumns2 = this.commonColumns.concat(this.changeColumn(lineModels))
          this.industryColumns4 = this.commonColumns.concat(this.changeColumn(amountLineModels))
          this.industryTableData2 = this.changeTableData(lineModels,'nums')
          this.industryTableData4 = this.changeTableData(amountLineModels,'amounts')
          this.industryTableData2_original = lineModels
          this.industryTableData4_original = amountLineModels
        } else {

        }
      }).finally(() => {
      })
    },

    projectCountIndustryContrast (obj) {
      let projectCountIndustryContrast = echarts.init(document.getElementById("project_count_industry_contrast"));
      if (obj.length<=0){
        return ;
      }
      let seriesData = [];
      for(let i=0;i<obj.length;i++) {
        let serData = {};
        serData['name'] = obj[i].name;
        serData['type'] = 'bar';
        serData['data'] = [obj[i].num];
        serData['barMaxWidth'] = 30
        serData['itemStyle'] = {color: chartColors[i]};
        seriesData[i] = serData;
      }
      const option = {
        title: {
          text: `${this.$t('charts.analysis.industryComparison.projectQuantityIndustryComparisonChart')}`,
          subtext: `${this.$t('charts.analysis.unit')} : ${this.$t('charts.analysis.ge')} `,
        },
        legend: {
          data: obj.map(nation => nation.name),
        },
        xAxis: {
          show:false,
          //data: obj.map(nation => nation.name),
          axisLabel: {
            interval: 0,
            rotate: 45,
            formatter: function(params) {
              let val = "";
              let show = localStorage.getItem('locale') === 'cn' ? 4 : 10;
              if (params.length > show) {
                val = params.substr(0, show) + '...';
                return val;
              } else {
                return params;
              }
            }
          }
        },
        series: seriesData
      };
      projectCountIndustryContrast.clear();
      projectCountIndustryContrast.setOption(chartBarOption);
      projectCountIndustryContrast.setOption(option);

      setTimeout(() => {
        this.projectCountIndustryContrastImg = projectCountIndustryContrast.getDataURL(this.imgOption).substring(22);
      }, 1000)
    },
    projectCountIndustryTrend (obj) {
      let projectCountIndustryTrend = echarts.init(document.getElementById("project_count_industry_trend"));
      if (obj.length<=0){
        return ;
      }
      let series = [];
      for (let i = 0; i < obj.length; i++) {
        let ser = {};
        ser["name"] = obj[i].name;
        ser["data"] = obj[i].nums;
        ser["type"] = "line";
        // ser["label"] = {
        //   show: true,
        //   color: chartColors[i % 16],
        //   position: "top",
        //   // rotate:40
        // };
        series[i] = ser;
      }
      const option = {
        title: {
          text: `${this.$t('charts.analysis.industryComparison.projectQuantityIndustryTrendChart')}`,
          subtext: `${this.$t('charts.analysis.unit')} : ${this.$t('charts.analysis.ge')} `,
        },
        xAxis: {
          data: obj[0].times,
        },
        series: series,
      };
      projectCountIndustryTrend.clear();
      projectCountIndustryTrend.setOption(chartLineOption);
      projectCountIndustryTrend.setOption(option);

      setTimeout(() => {
        this.projectCountIndustryTrendImg = projectCountIndustryTrend.getDataURL(this.imgOption).substring(22);
      }, 1000)
    },
    projectAmountIndustryContrast (obj) {
      let projectAmountIndustryContrast = echarts.init(document.getElementById("project_amount_industry_contrast"));
      if (obj.length<=0){
        return ;
      }
      let seriesData = [];
      for(let i=0;i<obj.length;i++) {
        let serData = {};
        serData['name'] = obj[i].name;
        serData['type'] = 'bar';
        serData['data'] = [obj[i].amount];
        serData['barMaxWidth'] = 30
        serData['itemStyle'] = {color: chartColors[i]};
        seriesData[i] = serData;
      }
      const option = {
        title: {
          text: `${this.$t('charts.analysis.industryComparison.industryComparisonChartOfProjectAmount')}`,
          subtext: `${this.$t('charts.analysis.unit')} : ${this.$t('charts.analysis.yuan')} `,
        },
        legend: {
          data: obj.map(nation => nation.name),
        },
        xAxis: {
          show:false,
          //data: obj.map(amount => amount.name),
          axisLabel: {
            interval: 0,
            rotate: 45,
            formatter: function(params) {
              let val = "";
              let show = localStorage.getItem('locale') === 'cn' ? 4 : 10;
              if (params.length > show) {
                val = params.substr(0, show) + '...';
                return val;
              } else {
                return params;
              }
            }
          }
        },
        series: seriesData
      };
      projectAmountIndustryContrast.clear();
      projectAmountIndustryContrast.setOption(chartBarOption);
      projectAmountIndustryContrast.setOption(option);

      setTimeout(() => {
        console.log("option", projectAmountIndustryContrast.getOption());
        this.projectAmountIndustryContrastImg = projectAmountIndustryContrast.getDataURL(this.imgOption).substring(22);
      }, 1000)
    },
    projectAmountIndustryTrend (obj) {
      let projectAmountIndustryTrend = echarts.init(document.getElementById("project_amount_industry_trend"));
      if (obj.length<=0){
        return ;
      }
      let series = [];
      for (let i = 0; i < obj.length; i++) {
        let ser = {};
        ser["name"] = obj[i].name;
        ser["data"] = obj[i].amounts;
        ser["type"] = "line";
        series[i] = ser;
      }
      const option = {
        title: {
          text: `${this.$t('charts.analysis.industryComparison.industryTrendChartOfProjectAmount')}`,
          subtext: `${this.$t('charts.analysis.unit')} : ${this.$t('charts.analysis.yuan')} `,
        },
        xAxis: {
          data: obj[0].times,
        },
        series: series,
      };
      projectAmountIndustryTrend.clear();
      projectAmountIndustryTrend.setOption(chartLineOption);
      projectAmountIndustryTrend.setOption(option);

      setTimeout(() => {
        this.projectAmountIndustryTrendImg = projectAmountIndustryTrend.getDataURL(this.imgOption).substring(22);
      }, 1000)
    },

    networkLoad() {
      let param = {
        from: 'cn',
        module: 'wl' , // 模块 gj/hy/wl/xx/sj/fx 分布式国家对比、行业对比、网络声量、信息正负面、商机分析、风险分析  默认为国家对比
      };
      param = Object.assign(param, this.queryParams);
      this.$pbrAxios.post('/front/analyses/search',param).then((data) => {
        let success = data.success;
        if (success){
          let sensitivityModels = data.result.sensitivityModels;
          let fromDistributionData = data.result.nationModels;
          let nationLineModels = data.result.nationLineModels;
          let informationContrastData = data.result.siteModels;

          this.networkTrend(sensitivityModels);
          this.networkFromDistribution(fromDistributionData);
          this.networkFromTrend(nationLineModels);
          this.networkFromContrast(informationContrastData);

          this.networkTableData1 = sensitivityModels
          this.networkTableData3 = fromDistributionData
          this.networkTableData4 = informationContrastData

          this.networkColumns2 = this.commonColumns.concat(this.changeColumn(nationLineModels))
          this.networkTableData2 = this.changeTableData(nationLineModels,'nums')
          this.networkTableData2_original = nationLineModels
        } else {

        }
      }).finally(() => {

      })
    },

    networkTrend(obj) {
      let networkTrend = echarts.init(document.getElementById("network_trend"));
      if (obj.length<=0){
        return ;
      }
      let series = [];
      let ser = {};
      ser["data"] = obj.map(o=>o.num);
      ser["type"] = "line";
      series[0] = ser;
      const option = {
        title: {
          text: `${this.$t('charts.analysis.networkVolume.volumeInformationTrendChart')}`,
          subtext: `${this.$t('charts.analysis.unit')} : ${this.$t('charts.analysis.ge')} `,
        },
        grid: {
          bottom: '5%',
          top: 60,
          left: 0,
          right: 0,
          containLabel: true
        },
        xAxis: {
          data: obj.map(o=>o.time),
        },
        series: series,
      };

      networkTrend.clear();
      networkTrend.setOption(chartLineOption);
      networkTrend.setOption(option);

      setTimeout(() => {
        this.networkTrendImg = networkTrend.getDataURL(this.imgOption).substring(22);
      }, 1000)
    },
    networkFromTrend(obj) {
      let networkFromTrend = echarts.init(document.getElementById("network_from_trend"));
      if (obj.length<=0){
        return ;
      }
      let series = [];
      for (let i = 0; i < obj.length; i++) {
        let ser = {};
        ser["name"] = obj[i].name;
        ser["data"] = obj[i].nums;
        ser["type"] = "line";
        // ser["label"] = {
        //   show: true,
        //   color: chartColors[i % 16],
        //   position: "top",
        //   // rotate:40
        // };
        series[i] = ser;
      }
      const option = {
        title: {
          text: `${this.$t('charts.analysis.networkVolume.informationSourceTrendChart')}`,
          subtext: `${this.$t('charts.analysis.unit')} : ${this.$t('charts.analysis.ge')} `,
        },
        xAxis: {
          data: obj[0].times,
        },
        series: series,
      };
      networkFromTrend.clear();
      networkFromTrend.setOption(chartLineOption);
      networkFromTrend.setOption(option);

      setTimeout(() => {
        this.networkFromTrendImg = networkFromTrend.getDataURL(this.imgOption).substring(22);
      }, 1000)
    },
    networkFromDistribution(obj) {
      let networkFromDistribution = echarts.init(document.getElementById("network_from_distribution"));
      if (obj.length<=0){
        return ;
      }
      let series = [];
      for (let i = 0; i < obj.length; i++) {
        let ser = {};
        ser["name"] = obj[i].name;
        ser["value"] = obj[i].num;
        series[i] = ser;
      }
      const option = {
        title: {
          text: `${this.$t('charts.analysis.networkVolume.distributionMapOfInformationSources')}`,
        },
        series: [
          {
            type: 'pie',
            top: '15%',
            radius: '60%',
            data:series,
            label: {
              normal:{
                show:true,
                formatter:'{@num} : {d}%'
              }
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      };
      networkFromDistribution.clear();
      networkFromDistribution.setOption(pieChartOption);
      networkFromDistribution.setOption(option);

      setTimeout(() => {
        this.networkFromDistributionImg = networkFromDistribution.getDataURL(this.imgOption).substring(22);
      }, 1000)
    },
    networkFromContrast(obj) {
      let networkFromContrast = echarts.init(document.getElementById("network_from_contrast"));
      if (obj.length<=0){
        return ;
      }
      let series = [];
      for (let i = 0; i < obj.length; i++) {
        let ser = {};
        ser["name"] = obj[i].name;
        ser["value"] = obj[i].num;
        series[i] = ser;
      }
      const option = {
        title: {
          text: `${this.$t('charts.analysis.networkVolume.comparisonOfInformationSources')}`,
        },
        series: [
          {
            type: 'pie',
            top: '15%',
            radius: '60%',
            data: series,
            label: {
              normal:{
                show:true,
                formatter:'{@num} : {d}%'
              }
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      };
      networkFromContrast.clear();
      networkFromContrast.setOption(pieChartOption);
      networkFromContrast.setOption(option);

      setTimeout(() => {
        this.networkFromContrastImg = networkFromContrast.getDataURL(this.imgOption).substring(22);
      }, 1000)
    },

    informationLoad() {
      let param = {
        from: 'cn',
        module: 'xx' , // 模块 gj/hy/wl/xx/sj/fx 分布式国家对比、行业对比、网络声量、信息正负面、商机分析、风险分析  默认为国家对比
      };
      param = Object.assign(param, this.queryParams);
      this.$pbrAxios.post('/front/analyses/search',param).then((data) => {
        let success = data.success;
        if (success){
          let positiveModels = data.result.positiveModels;
          let sensitivePercentData = data.result.nationModels;
          let positiveLineModels = data.result.positiveLineModels;
          let positiveSourceModels = data.result.positiveSourceModels;
          let lineModels = data.result.lineModels;
          let sensitiveDistributionData = data.result.sourceModels;

          this.informationContrast(positiveModels);
          this.informationPercent(sensitivePercentData);
          this.informationPositiveTrend(positiveLineModels);
          this.informationPositiveDistribution(positiveSourceModels);
          this.informationTrend(lineModels);
          this.informationDistribution(sensitiveDistributionData);

          this.informationTableData1 = positiveModels
          this.informationTableData2 = sensitivePercentData
          this.informationTableData3 = positiveLineModels
          this.informationTableData4 = positiveSourceModels
          this.informationTableData5 = lineModels
          this.informationTableData6 = sensitiveDistributionData

        } else {

        }
      }).finally(() => {
      })
    },

    informationContrast(obj) {
      let informationContrast = echarts.init(document.getElementById("information_contrast"))
      if (obj.length<=0){
        return ;
      }
      let series = [];
      series[0] = {name: `${this.$t('charts.analysis.positiveAndNegativeSidesOfInformation.positive')}`, data: obj.map(o=>o.positive), type: 'bar', barMaxWidth: 40, itemStyle: {
          borderRadius: 3,
        },label: {
          show: true,
          color: chartColors[0],
          position: "top",
          // rotate:40
        }};
      series[1] = {name: `${this.$t('charts.analysis.positiveAndNegativeSidesOfInformation.negative')}`, data: obj.map(o=>o.negative), type: 'bar', barMaxWidth: 40, itemStyle: {
          borderRadius: 3,
        },label: {
          show: true,
          color: chartColors[1],
          position: "top",
          // rotate:40
        }};
      const option = {
        title: {
          text: `${this.$t('charts.analysis.positiveAndNegativeSidesOfInformation.informationPositiveAndNegativeComparisonDiagram')}`,
          subtext: `${this.$t('charts.analysis.unit')} : ${this.$t('charts.analysis.ge')} `,
        },
        legend: {
          top: 36,
        },
        grid: {
          top: 60,
        },
        xAxis: {
          data: obj.map(o=>o.time),
        },
        series: series
      }
      informationContrast.clear();
      informationContrast.setOption(chartBarOption);
      informationContrast.setOption(option);

      setTimeout(() => {
        this.informationContrastImg = informationContrast.getDataURL(this.imgOption).substring(22);
      }, 1000)
    },
    informationPercent(obj) {
      let informationPercent = echarts.init(document.getElementById("information_percent"))
      let series = [];
      series[0] = {name: `${this.$t('charts.analysis.positiveAndNegativeSidesOfInformation.positive')}`, data: obj.map(o=>o.positive), type: 'bar', barMaxWidth: 40, itemStyle: {
          borderRadius: 3,
        },label: {
          show: true,
          color: chartColors[0],
          position: "top",
          // rotate:40
        }};
      series[1] = {name: `${this.$t('charts.analysis.positiveAndNegativeSidesOfInformation.negative')}`, data: obj.map(o=>o.negative), type: 'bar', barMaxWidth: 40, itemStyle: {
          borderRadius: 3,
        },label: {
          show: true,
          color: chartColors[1],
          position: "top",
          // rotate:40
        }};
      const option = {
        title: {
          text: `${this.$t('charts.analysis.positiveAndNegativeSidesOfInformation.proportionOfSensitiveInformation')}`,
          subtext: `${this.$t('charts.analysis.unit')} : ${this.$t('charts.analysis.ge')} `,
        },
        legend: {
          top: 36,
        },
        grid: {
          top: 60,
        },
        xAxis: {
          show:false,
          data: obj.map(o=>o.name),
        },
        series: series
      }
      informationPercent.clear();
      informationPercent.setOption(chartBarOption);
      informationPercent.setOption(option);

      setTimeout(() => {
        this.informationPercentImg = informationPercent.getDataURL(this.imgOption).substring(22);
      }, 1000)
    },
    informationPositiveTrend(obj) {
      let informationPositiveTrend = echarts.init(document.getElementById("information_positive_trend"))
      if (obj.length<=0){
        return ;
      }
      let series = [];
      let ser = {};
      ser["data"] = obj.map(o=>o.num);
      ser["type"] = "line";
      series[0] = ser;
      const option = {
        grid: {
          bottom: '5%',
          top: 60,
          left: 0,
          right: 0,
          containLabel: true
        },
        title: {
          text: `${this.$t('charts.analysis.positiveAndNegativeSidesOfInformation.positiveInformationTrendChart')}`,
          subtext: `${this.$t('charts.analysis.unit')} : ${this.$t('charts.analysis.ge')} `,
        },
        xAxis: {
          data: obj.map(o=>o.time),
        },
        series: series,
      };
      informationPositiveTrend.clear();
      informationPositiveTrend.setOption(chartLineOption);
      informationPositiveTrend.setOption(option);

      setTimeout(() => {
        this.positiveLineModelsImg = informationPositiveTrend.getDataURL(this.imgOption).substring(22);
      }, 1000)
    },
    informationPositiveDistribution(obj) {
      let informationPositiveDistribution = echarts.init(document.getElementById("information_positive_distribution"))
      if (obj.length<=0){
        return ;
      }
      let series = [];
      for (let i = 0; i < obj.length; i++) {
        let ser = {};
        ser["name"] = obj[i].name;
        ser["value"] = obj[i].num;
        series[i] = ser;
      }
      const option = {
        title: {
          text: `${this.$t('charts.analysis.positiveAndNegativeSidesOfInformation.distributionOfPositiveInformationSources')}`,
        },
        series: [
          {
            type: 'pie',
            top: '15%',
            radius: '60%',
            data: series,
            label: {
              normal:{
                show:true,
                formatter:'{@num} : {d}%'
              }
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      };
      informationPositiveDistribution.clear();
      informationPositiveDistribution.setOption(pieChartOption);
      informationPositiveDistribution.setOption(option);

      setTimeout(() => {
        this.positiveSourceModelsImg = informationPositiveDistribution.getDataURL(this.imgOption).substring(22);
      }, 1000)
    },
    informationTrend(obj) {
      let informationTrend = echarts.init(document.getElementById("information_trend"))
      if (obj.length<=0){
        return ;
      }
      let series = [];
      let ser = {};
      ser["data"] = obj.map(o=>o.num);
      ser["type"] = "line";
      series[0] = ser;
      const option = {
        grid: {
          bottom: '5%',
          top: 60,
          left: 0,
          right: 0,
          containLabel: true
        },
        title: {
          text: `${this.$t('charts.analysis.positiveAndNegativeSidesOfInformation.sensitiveInformationTrendChart')}`,
          subtext: `${this.$t('charts.analysis.unit')} : ${this.$t('charts.analysis.ge')} `,
        },
        xAxis: {
          data: obj.map(o=>o.time),
        },
        series: series,
      };
      informationTrend.clear();
      informationTrend.setOption(chartLineOption);
      informationTrend.setOption(option);

      setTimeout(() => {
        this.informationTrendImg = informationTrend.getDataURL(this.imgOption).substring(22);
      }, 1000)
    },
    informationDistribution(obj) {
      let informationDistribution = echarts.init(document.getElementById("information_distribution"))
      if (obj.length<=0){
        return ;
      }
      let series = [];
      for (let i = 0; i < obj.length; i++) {
        let ser = {};
        ser["name"] = obj[i].name;
        ser["value"] = obj[i].num;
        series[i] = ser;
      }
      const option = {
        title: {
          text: `${this.$t('charts.analysis.positiveAndNegativeSidesOfInformation.distributionOfSensitiveInformationSources')}`,
        },
        series: [
          {
            type: 'pie',
            top: '15%',
            radius: '60%',
            data: series,
            label: {
              normal:{
                show:true,
                formatter:'{@num} : {d}%'
              }
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      };
      informationDistribution.clear();
      informationDistribution.setOption(pieChartOption);
      informationDistribution.setOption(option);

      setTimeout(() => {
        this.informationDistributionImg = informationDistribution.getDataURL(this.imgOption).substring(22);
      }, 1000)
    },

    businessLoad() {
      let param = {
        from: 'cn',
        module: 'sj' , // 模块 gj/hy/wl/xx/sj/fx 分布式国家对比、行业对比、网络声量、信息正负面、商机分析、风险分析  默认为国家对比
      };
      param = Object.assign(param, this.queryParams);
      this.$pbrAxios.post('/front/analyses/search',param).then((data) => {
        let success = data.success;
        if (success){
          let numModels = data.result.numModels;
          let countryDistributionData = data.result.nationModels;
          let typeLineModels = data.result.typeLineModels;
          let typeDistributionData = data.result.typeModels;

          this.businessCountryTrend(numModels);
          this.businessCountryDistribution(countryDistributionData);
          this.businessIndustryTrend(typeLineModels);
          this.businessIndustryDistribution(typeDistributionData);

          this.businessTableData3 = countryDistributionData
          this.businessTableData4 = typeDistributionData

          this.businessColumns1 = this.commonColumns.concat(this.changeColumn(numModels))
          this.businessColumns2 = this.commonColumns.concat(this.changeColumn(typeLineModels))
          this.businessTableData1 = this.changeTableData(numModels,'nums')
          this.businessTableData2 = this.changeTableData(typeLineModels,'nums')

          this.businessTableData1_original = numModels
          this.businessTableData2_original = typeLineModels

        } else {

        }
      }).finally(() => {

      })
    },

    businessCountryTrend(obj) {
      let businessCountryTrend = echarts.init(document.getElementById("business_country_trend"));
      if (obj.length<=0){
        return ;
      }
      let series = [];
      for (let i = 0; i < obj.length; i++) {
        let ser = {};
        ser["name"] = obj[i].name;
        ser["data"] = obj[i].nums;
        ser["type"] = "line";
        // ser["label"] = {
        //   show: true,
        //   color: chartColors[i % 16],
        //   position: "top",
        //   // rotate:40
        // };
        series[i] = ser;
      }
      const option = {
        title: {
          text: `${this.$t('charts.analysis.opportunityAnalysis.businessOpportunityCountryTrendChart')}`,
          subtext: `${this.$t('charts.analysis.unit')} : ${this.$t('charts.analysis.tiao')} `,
        },
        xAxis: {
          data: obj[0].times,
        },
        series: series,
      };

      businessCountryTrend.clear();
      businessCountryTrend.setOption(chartLineOption);
      businessCountryTrend.setOption(option);

      setTimeout(() => {
        this.businessCountryTrendImg = businessCountryTrend.getDataURL(this.imgOption).substring(22);
      }, 1000)
    },
    businessIndustryTrend(obj) {
      let businessIndustryTrend = echarts.init(document.getElementById("business_industry_trend"));
      if (obj.length<=0){
        return ;
      }
      let series = [];
      for (let i = 0; i < obj.length; i++) {
        let ser = {};
        ser["name"] = obj[i].name;
        ser["data"] = obj[i].nums;
        ser["type"] = "line";
        // ser["label"] = {
        //   show: true,
        //   color: chartColors[i % 16],
        //   position: "top",
        //   // rotate:40
        // };
        series[i] = ser;
      }
      const option = {
        title: {
          text: `${this.$t('charts.analysis.opportunityAnalysis.businessOpportunityTypeTrendChart')}`,
          subtext: `${this.$t('charts.analysis.unit')} : ${this.$t('charts.analysis.tiao')} `,
        },
        xAxis: {
          data: obj[0].times,
        },
        series: series,
      };
      businessIndustryTrend.clear();
      businessIndustryTrend.setOption(chartLineOption);
      businessIndustryTrend.setOption(option);

      setTimeout(() => {
        this.businessIndustryTrendImg = businessIndustryTrend.getDataURL(this.imgOption).substring(22);
      }, 1000)
    },
    businessCountryDistribution(obj) {
      let businessCountryDistribution = echarts.init(document.getElementById("business_country_distribution"));
      if (obj.length<=0){
        return ;
      }
      let series = [];
      for (let i = 0; i < obj.length; i++) {
        let ser = {};
        ser["name"] = obj[i].name;
        ser["value"] = obj[i].num;
        series[i] = ser;
      }
      const option = {
        title: {
          text: `${this.$t('charts.analysis.opportunityAnalysis.businessOpportunityCountryDistributionMap')}`
        },
        series: [
          {
            type: 'pie',
            top: '15%',
            radius: '60%',
            data: series,
            label: {
              normal:{
                show:true,
                formatter:'{@num} : {d}%'
              }
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      };
      businessCountryDistribution.clear();
      businessCountryDistribution.setOption(pieChartOption);
      businessCountryDistribution.setOption(option);

      setTimeout(() => {
        this.businessCountryDistributionImg = businessCountryDistribution.getDataURL(this.imgOption).substring(22);
      }, 1000)
    },
    businessIndustryDistribution(obj) {
      let businessIndustryDistribution = echarts.init(document.getElementById("business_industry_distribution"));
      if (obj.length<=0){
        return ;
      }
      let series = [];
      for (let i = 0; i < obj.length; i++) {
        let ser = {};
        ser["name"] = obj[i].name;
        ser["value"] = obj[i].num;
        series[i] = ser;
      }
      const option = {
        title: {
          text: `${this.$t('charts.analysis.opportunityAnalysis.businessOpportunityTypeDistributionMap')}`
        },
        series: [
          {
            type: 'pie',
            top: '15%',
            radius: '60%',
            data: series,
            label: {
              normal:{
                show:true,
                formatter:'{@num} : {d}%'
              }
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      };
      businessIndustryDistribution.clear();
      businessIndustryDistribution.setOption(pieChartOption);
      businessIndustryDistribution.setOption(option);

      setTimeout(() => {
        this.businessIndustryDistributionImg = businessIndustryDistribution.getDataURL(this.imgOption).substring(22);
      }, 1000)
    },

    riskLoad() {
      let param = {
        from: 'cn',
        module: 'fx' , // 模块 gj/hy/wl/xx/sj/fx 分布式国家对比、行业对比、网络声量、信息正负面、商机分析、风险分析  默认为国家对比
      };
      param = Object.assign(param, this.queryParams);
      this.$pbrAxios.post('/front/analyses/search',param).then((data) => {
        let success = data.success;
        if (success){
          let numModels = data.result.numModels;
          let countryDistributionData = data.result.nationModels;
          let typeLineModels = data.result.typeLineModels;
          let typeDistributionData = data.result.typeModels;

          this.riskCountryTrend(numModels);
          this.riskCountryDistribution(countryDistributionData);
          this.riskCategoryTrend(typeLineModels);
          this.riskCategoryDistribution(typeDistributionData);

          this.riskTableData3 = typeDistributionData
          this.riskTableData4 = countryDistributionData

          this.riskColumns1 = this.commonColumns.concat(this.changeColumn(typeLineModels))
          this.riskColumns2 = this.commonColumns.concat(this.changeColumn(numModels))
          this.riskTableData1 = this.changeTableData(typeLineModels,'nums')
          this.riskTableData2 = this.changeTableData(numModels,'nums')

          this.riskTableData1_original = typeLineModels
          this.riskTableData2_original = numModels
        } else {

        }

      }).finally(() => {
      })
    },

    riskCategoryTrend(obj) {
      let riskCategoryTrend = echarts.init(document.getElementById("risk_category_trend"));
      if (obj.length<=0){
        return ;
      }
      let series = [];
      for (let i = 0; i < obj.length; i++) {
        let ser = {};
        ser["name"] = obj[i].name;
        ser["data"] = obj[i].nums;
        ser["type"] = "line";
        // ser["label"] = {
        //   show: true,
        //   color: chartColors[i % 16],
        //   position: "top",
        //   // rotate:40
        // };
        series[i] = ser;
      }
      const option = {
        title: {
          text: `${this.$t('charts.analysis.riskAnalysis.riskEventCategoryTrendChart')}`,
          subtext: `${this.$t('charts.analysis.unit')} : ${this.$t('charts.analysis.ge')} `,
        },
        xAxis: {
          data: obj[0].times,
        },
        series: series,
      };
      riskCategoryTrend.clear();
      riskCategoryTrend.setOption(chartLineOption);
      riskCategoryTrend.setOption(option);

      setTimeout(() => {
        this.riskCategoryTrendImg = riskCategoryTrend.getDataURL(this.imgOption).substring(22);
      }, 1000)
    },
    riskCountryTrend(obj) {
      let riskCountryTrend = echarts.init(document.getElementById("risk_country_trend"));
      if (obj.length<=0){
        return ;
      }
      let series = [];
      for (let i = 0; i < obj.length; i++) {
        let ser = {};
        ser["name"] = obj[i].name;
        ser["data"] = obj[i].nums;
        ser["type"] = "line";
        // ser["label"] = {
        //   show: true,
        //   color: chartColors[i % 16],
        //   position: "top",
        //   // rotate:40
        // };
        series[i] = ser;
      }
      const option = {
        title: {
          text: `${this.$t('charts.analysis.riskAnalysis.nationalTrendChartOfRiskEvents')}`,
          subtext: `${this.$t('charts.analysis.unit')} : ${this.$t('charts.analysis.ge')} `,
        },
        xAxis: {
          data: obj[0].times,
        },
        series: series,
      };
      riskCountryTrend.clear();
      riskCountryTrend.setOption(chartLineOption);
      riskCountryTrend.setOption(option);

      setTimeout(() => {
        this.riskCountryTrendImg = riskCountryTrend.getDataURL(this.imgOption).substring(22);
      }, 1000)
    },
    riskCountryDistribution(obj) {
      let riskCountryDistribution = echarts.init(document.getElementById("risk_country_distribution"));
      if (obj.length<=0){
        return ;
      }
      let series = [];
      for (let i = 0; i < obj.length; i++) {
        let ser = {};
        ser["name"] = obj[i].name;
        ser["value"] = obj[i].num;
        series[i] = ser;
      }
      const option = {
        title: {
          text: `${this.$t('charts.analysis.riskAnalysis.countryDistributionMapOfRiskEvents')}`
        },
        series: [
          {
            type: 'pie',
            top: '15%',
            radius: '60%',
            data: series,
            label: {
              normal:{
                show:true,
                formatter:'{@num} : {d}%'
              }
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      };
      riskCountryDistribution.clear();
      riskCountryDistribution.setOption(pieChartOption);
      riskCountryDistribution.setOption(option);

      setTimeout(() => {
        this.riskCountryDistributionImg = riskCountryDistribution.getDataURL(this.imgOption).substring(22);
      }, 1000)
    },
    riskCategoryDistribution(obj) {
      let riskCategoryDistribution = echarts.init(document.getElementById("risk_category_distribution"));
      if (obj.length<=0){
        return ;
      }
      let series = [];
      for (let i = 0; i < obj.length; i++) {
        let ser = {};
        ser["name"] = obj[i].name;
        ser["value"] = obj[i].num;
        series[i] = ser;
      }
      const option = {
        title: {
          text: `${this.$t('charts.analysis.riskAnalysis.riskEventCategoryDistributionMap')}`
        },
        series: [
          {
            type: 'pie',
            top: '15%',
            radius: '60%',
            data: series,
            label: {
              normal:{
                show:true,
                formatter:'{@num} : {d}%'
              }
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      };
      riskCategoryDistribution.clear();
      riskCategoryDistribution.setOption(pieChartOption);
      riskCategoryDistribution.setOption(option);

      setTimeout(() => {
        this.riskCategoryDistributionImg = riskCategoryDistribution.getDataURL(this.imgOption).substring(22);
      }, 1000)
    },

    getModelChartsData() {
      let param = {
        from: 'cn',
        module: '' , // 模块 gj/hy/wl/xx/sj/fx 分布式国家对比、行业对比、网络声量、信息正负面、商机分析、风险分析  默认为国家对比
        summary: 1,
        project: 1
      };
      param = Object.assign(param, this.queryParams);
      this.$pbrAxios.post('/front/charts/getModelChartsData',param).then((data) => {
        let success = data.success;
        if (success){
          this.summary = data.result.summaryList
          this.tableData = data.result.project
        } else {

        }

      }).finally(() => {
      })
    },

    submit() {
      let param = {
        from: 'cn',
        module: '' , // 模块 gj/hy/wl/xx/sj/fx 分布式国家对比、行业对比、网络声量、信息正负面、商机分析、风险分析  默认为国家对比
        watermark: this.watermark,
      };

      if (this.selectedTree.length <= 0){
        this.$message.warning(`${this.$t('charts.analysis.exportSelected')}`);
        return;
      }

      if (this.isCheck(1)){
        param.summary = 1
      } else {
        param.summary = 0
      }

      if (this.isCheck(8)){
        param.project = 1
      } else {
        param.project = 0
      }

      param.nationComparisonData = {};
      if (this.isCheck(2)) {
        param.nationComparisonData.nationModelsImg = this.projectCountCountryContrastImg;
        param.nationComparisonData.nationLineModelsImg = this.projectCountCountryTrendImg;
        param.nationComparisonData.amountModelsImg = this.projectAmountCountryContrastImg;
        param.nationComparisonData.amountLineModelsImg = this.projectAmountCountryTrendImg;

        param.nationComparisonData.nationModels = this.projectTableData1;
        param.nationComparisonData.nationLineModels = this.projectTableData2_original;
        param.nationComparisonData.amountModels = this.projectTableData3;
        param.nationComparisonData.amountLineModels = this.projectTableData4_original;
      } else {
        if (this.isCheck(21)) {
          param.nationComparisonData.nationModelsImg = this.projectCountCountryContrastImg;
          param.nationComparisonData.nationModels = this.projectTableData1;
        }
        if (this.isCheck(22)) {
          param.nationComparisonData.nationLineModelsImg = this.projectCountCountryTrendImg;
          param.nationComparisonData.nationLineModels = this.projectTableData2_original;
        }
        if (this.isCheck(23)) {
          param.nationComparisonData.amountModelsImg = this.projectAmountCountryContrastImg;
          param.nationComparisonData.amountModels = this.projectTableData3;
        }
        if (this.isCheck(24)) {
          param.nationComparisonData.amountLineModels = this.projectAmountCountryTrendImg;
          param.nationComparisonData.amountLineModels = this.projectTableData4_original;
        }
      }

      param.industryComparisonData = {};
      if(this.isCheck(3)) {
        param.industryComparisonData.modelsImg = this.projectCountIndustryContrastImg;
        param.industryComparisonData.lineModelsImg = this.projectCountIndustryTrendImg;
        param.industryComparisonData.amountModelsImg = this.projectAmountIndustryContrastImg;
        param.industryComparisonData.amountLineModelsImg = this.projectAmountIndustryTrendImg;

        param.industryComparisonData.models = this.industryTableData1;
        param.industryComparisonData.lineModels = this.industryTableData2_original;
        param.industryComparisonData.amountModels = this.industryTableData3;
        param.industryComparisonData.amountLineModels = this.industryTableData4_original;
      } else {
        if (this.isCheck(31)) {
          param.industryComparisonData.modelsImg = this.projectCountIndustryContrastImg;
          param.industryComparisonData.models = this.industryTableData1;
        }
        if (this.isCheck(32)) {
          param.industryComparisonData.lineModelsImg = this.projectCountIndustryTrendImg;
          param.industryComparisonData.lineModels = this.industryTableData2_original;
        }
        if (this.isCheck(33)) {
          param.industryComparisonData.amountModelsImg = this.projectAmountIndustryContrastImg;
          param.industryComparisonData.amountModels = this.industryTableData3;
        }
        if (this.isCheck(34)) {
          param.industryComparisonData.amountLineModelsImg = this.projectAmountIndustryTrendImg;
          param.industryComparisonData.amountLineModels = this.industryTableData4_original;
        }
      }

      param.networkVolumeData = {};
      if(this.isCheck(4)) {
        param.networkVolumeData.sensitivityModelsImg = this.networkTrendImg;
        param.networkVolumeData.nationLineModelsImg = this.networkFromTrendImg;
        param.networkVolumeData.nationModelsImg = this.networkFromDistributionImg;
        param.networkVolumeData.siteModelsImg = this.networkFromContrastImg;

        param.networkVolumeData.sensitivityModels = this.networkTableData1;
        param.networkVolumeData.nationLineModels = this.networkTableData2_original;
        param.networkVolumeData.nationModels = this.networkTableData3;
        param.networkVolumeData.siteModels = this.networkTableData4;
      } else {
        if (this.isCheck(41)) {
          param.networkVolumeData.sensitivityModelsImg = this.networkTrendImg;
          param.networkVolumeData.sensitivityModels = this.networkTableData1;
        }
        if (this.isCheck(42)) {
          param.networkVolumeData.nationLineModelsImg = this.networkFromTrendImg;
          param.networkVolumeData.nationLineModels = this.networkTableData2_original;
        }
        if (this.isCheck(43)) {
          param.networkVolumeData.nationModelsImg = this.networkFromDistributionImg;
          param.networkVolumeData.nationModels = this.networkTableData3;
        }
        if (this.isCheck(44)) {
          param.networkVolumeData.siteModelsImg = this.networkFromContrastImg;
          param.networkVolumeData.siteModels = this.networkTableData4;
        }
      }

      param.informationSurfacesData = {};
      if(this.isCheck(5)) {
        param.informationSurfacesData.positiveModelsImg = this.informationContrastImg;
        param.informationSurfacesData.nationModelsImg = this.informationPercentImg;
        param.informationSurfacesData.positiveLineModelsImg = this.positiveLineModelsImg;
        param.informationSurfacesData.positiveSourceModelsImg = this.positiveSourceModelsImg;
        param.informationSurfacesData.lineModelsImg = this.informationTrendImg;
        param.informationSurfacesData.sourceModelsImg = this.informationDistributionImg;

        param.informationSurfacesData.positiveModels = this.informationTableData1;
        param.informationSurfacesData.nationModels = this.informationTableData2;
        param.informationSurfacesData.positiveLineModels = this.informationTableData3;
        param.informationSurfacesData.positiveSourceModels = this.informationTableData4;
        param.informationSurfacesData.lineModels = this.informationTableData5;
        param.informationSurfacesData.sourceModels = this.informationTableData6;
      } else {
        if (this.isCheck(51)) {
          param.informationSurfacesData.positiveModelsImg = this.informationContrastImg;
          param.informationSurfacesData.positiveModels = this.informationTableData1;
        }
        if (this.isCheck(52)) {
          param.informationSurfacesData.nationModelsImg = this.informationPercentImg;
          param.informationSurfacesData.nationModels = this.informationTableData2;
        }
        if (this.isCheck(53)) {
          param.informationSurfacesData.positiveLineModelsImg = this.informationTrendImg;
          param.informationSurfacesData.positiveLineModels = this.informationTableData3;
        }
        if (this.isCheck(54)) {
          param.informationSurfacesData.positiveSourceModelsImg = this.informationDistributionImg;
          param.informationSurfacesData.positiveSourceModels = this.informationTableData4;
        }
        if (this.isCheck(55)) {
          param.informationSurfacesData.lineModelsImg = this.informationTrendImg;
          param.informationSurfacesData.lineModels = this.informationTableData5;
        }
        if (this.isCheck(56)) {
          param.informationSurfacesData.sourceModelsImg = this.informationDistributionImg;
          param.informationSurfacesData.sourceModels = this.informationTableData6;
        }
      }

      param.businessAnalysisData = {};
      if(this.isCheck(6)) {
        param.businessAnalysisData.numModelsImg = this.businessCountryTrendImg;
        param.businessAnalysisData.typeLineModelsImg = this.businessIndustryTrendImg;
        param.businessAnalysisData.nationModelsImg = this.businessCountryDistributionImg;
        param.businessAnalysisData.typeModelsImg = this.businessIndustryDistributionImg;

        param.businessAnalysisData.numModels = this.businessTableData1_original;
        param.businessAnalysisData.typeLineModels = this.businessTableData2_original;
        param.businessAnalysisData.nationModels = this.businessTableData3;
        param.businessAnalysisData.typeModels = this.businessTableData4;
      } else {
        if (this.isCheck(61)) {
          param.businessAnalysisData.numModelsImg = this.businessCountryTrendImg;
          param.businessAnalysisData.numModels = this.businessTableData1_original;
        }
        if (this.isCheck(62)) {
          param.businessAnalysisData.typeLineModelsImg = this.businessIndustryTrendImg;
          param.businessAnalysisData.typeLineModels = this.businessTableData2_original;
        }
        if (this.isCheck(63)) {
          param.businessAnalysisData.nationModelsImg = this.businessCountryDistributionImg;
          param.businessAnalysisData.nationModels = this.businessTableData3;
        }
        if (this.isCheck(64)) {
          param.businessAnalysisData.typeModelsImg = this.businessIndustryDistributionImg;
          param.businessAnalysisData.typeModels = this.businessTableData4;
        }
      }

      param.riskAnalysisData = {};
      if(this.isCheck(7)) {
        param.riskAnalysisData.typeLineModelsImg = this.riskCategoryTrendImg;
        param.riskAnalysisData.numModelsImg = this.riskCountryTrendImg;
        param.riskAnalysisData.nationModelsImg = this.riskCountryDistributionImg;
        param.riskAnalysisData.typeModelsImg = this.riskCategoryDistributionImg;

        param.riskAnalysisData.typeLineModels = this.riskTableData1_original;
        param.riskAnalysisData.numModels = this.riskTableData2_original;
        param.riskAnalysisData.typeModels = this.riskTableData3;
        param.riskAnalysisData.nationModels = this.riskTableData4;
      } else {
        if (this.isCheck(71)) {
          param.riskAnalysisData.typeLineModelsImg = this.riskCategoryTrendImg;
          param.riskAnalysisData.typeLineModels = this.riskTableData1_original;
        }
        if (this.isCheck(72)) {
          param.riskAnalysisData.numModelsImg = this.riskCountryTrendImg;
          param.riskAnalysisData.numModels = this.riskTableData2_original;
        }
        if (this.isCheck(73)) {
          param.riskAnalysisData.nationModelsImg = this.riskCountryDistributionImg;
          param.riskAnalysisData.typeModels = this.riskTableData3;
        }
        if (this.isCheck(74)) {
          param.riskAnalysisData.typeModelsImg = this.riskCategoryDistributionImg;
          param.riskAnalysisData.nationModels = this.riskTableData4;
        }
      }

      param = Object.assign(param, this.queryParams);

      this.$refs.tree.setCheckedKeys([]);
      this.selectedTree = [];
      this.defaultExpandedKeys = [];

      // this.reportMessage = this.$message.success({message:"分析报告正在准备中，请稍等!",duration: 10});
      //this.$iMessage.loading({content:`${this.$t('charts.analysis.exporting')}`,duration:10})
/*      this.$pbrAxios.post('/front/charts/exportEchartsWordIncludeData',param).then((data) => {
        let success = data.success;
        let that = this;
        if (success){*/
          // window.location.href = data.result;
          exportFilePost( '/front/charts/exportEchartsWordIncludeData',param, `${this.$t('header.analysis')}`,contentType.word, '.docx', ()=>{
            //this.$iMessage.destroy()
            // this.reportMessage.close()
            that.$emit("exportSuccess");
          })
       /* } else {
          this.$message.error(data.message);
        }
      }).finally(() => {
        //this.$iMessage.destroy()
      })*/
    }
  },
  mounted () {

  }
}
</script>

<style scoped>
.analysis-echart-div {
  display: flex;
  width:calc(60vw - 24px);
  height: 400px;
  margin-top: 20px;
  align-items: center;
  text-align: center;
  background: white;
}

p {
  text-indent: 2em;
  white-space: pre-wrap;
}
.dialog-footer{
  align-items: center;
  label{
    margin-bottom: 0;
  }
}
</style>
